import { INDUSTRIES, PROFILE } from "../../lib/data";
import { ArrowUpRight, Download } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const WhatsNextHeading = () => (
  <div className="grid grid-cols-12 gap-6 mb-10 md:mb-14">
    <div className="col-span-12 md:col-span-7">
      <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
        08 — What&apos;s Next
      </div>
      <h2 className="text-4xl md:text-7xl font-bold tracking-tight leading-[0.92]">
        I&apos;m looking to lead brands<br />
        <span className="opacity-50">where marketing is expected to</span><br />
        influence business outcomes
        <span className="text-[var(--accent)]">.</span>
      </h2>
    </div>
  </div>
);

const NextCTAs = () => (
  <div className="mt-10 flex flex-wrap gap-3">
    <a
      href={`mailto:${PROFILE.email}`}
      data-testid="cta-email"
      className="inline-flex items-center gap-2 bg-[var(--ink)] text-[var(--paper)] px-5 py-3 text-[11px] tracking-[0.2em] uppercase font-medium hover:bg-[var(--paper)] hover:text-[var(--ink)] border border-[var(--ink)] transition-colors"
    >
      Start a conversation
      <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.75} />
    </a>
    <a
      href={`${BACKEND_URL}/api/resume/download`}
      data-testid="cta-resume"
      className="inline-flex items-center gap-2 border border-[var(--ink)] px-5 py-3 text-[11px] tracking-[0.2em] uppercase font-medium hover:bg-[var(--ink)] hover:text-[var(--paper)] transition-colors"
    >
      <Download className="w-3.5 h-3.5" strokeWidth={1.75} />
      Download the PDF
    </a>
  </div>
);

const IndustryList = ({ items }) => (
  <div className="col-span-12 md:col-span-6 md:col-start-7">
    <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-5">
      Industries of Interest
    </div>
    <ul className="hairline-t border-t">
      {items.map((ind, i) => (
        <li
          key={ind}
          data-testid={`industry-${i}`}
          className="hairline-b border-b py-4 md:py-5 flex items-baseline justify-between text-xl md:text-3xl font-bold tracking-tight"
        >
          <span>{ind}</span>
          <span className="font-mono text-[10px] opacity-40">
            /{String(i + 1).padStart(2, "0")}
          </span>
        </li>
      ))}
    </ul>
  </div>
);

export const WhatsNext = () => {
  return (
    <section
      id="next"
      data-testid="next-section"
      className="hairline-b border-b"
    >
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-28">
        <WhatsNextHeading />

        <div className="grid grid-cols-12 gap-6 hairline-t border-t pt-10 md:pt-14">
          <div className="col-span-12 md:col-span-5">
            <p className="text-base md:text-lg leading-relaxed text-[var(--muted)] max-w-prose">
              The opportunities that excite me most sit at the intersection of
              business strategy, creativity, integrated marketing and
              leadership — not just communication.
            </p>
            <NextCTAs />
          </div>
          <IndustryList items={INDUSTRIES} />
        </div>
      </div>
    </section>
  );
};
